export default __webpack_public_path__ + "static/media/simulation_testseries.38b00e47.png";